var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifePreserver(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.1172 91.1224C111.894 70.3458 111.894 36.6602 91.1172 15.8836C70.3405 -4.89302 36.655 -4.89302 15.8783 15.8836C-4.8983 36.6602 -4.8983 70.3458 15.8783 91.1224C36.655 111.899 70.3405 111.899 91.1172 91.1224Z",
    fill: "white",
    stroke: "#03324C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5029 104.29C81.2824 104.29 103.802 81.5519 103.802 53.503C103.802 25.4542 81.2824 2.71613 53.5029 2.71613C25.7235 2.71613 3.20386 25.4542 3.20386 53.503C3.20386 81.5519 25.7235 104.29 53.5029 104.29Z",
    stroke: "#03324C",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.473 92.7149C75.1324 92.7149 92.6909 75.1564 92.6909 53.497C92.6909 31.8376 75.1324 14.2791 53.473 14.2791C31.8136 14.2791 14.2551 31.8376 14.2551 53.497C14.2551 75.1564 31.8136 92.7149 53.473 92.7149Z",
    stroke: "#03324C",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.473 75.2981C65.5134 75.2981 75.2741 65.5374 75.2741 53.497C75.2741 41.4566 65.5134 31.6959 53.473 31.6959C41.4326 31.6959 31.6719 41.4566 31.6719 53.497C31.6719 65.5374 41.4326 75.2981 53.473 75.2981Z",
    stroke: "#03324C",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4568 45.5775H77.1169C73.2154 45.5775 70.0526 48.7403 70.0526 52.6418V54.2678C70.0526 58.1693 73.2154 61.3321 77.1169 61.3321H89.4568C93.3583 61.3321 96.5211 58.1693 96.5211 54.2678V52.6418C96.5211 48.7403 93.3583 45.5775 89.4568 45.5775Z",
    fill: "white",
    stroke: "#03324C",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4315 45.5775H17.0916C13.1901 45.5775 10.0273 48.7403 10.0273 52.6418V54.2678C10.0273 58.1693 13.1901 61.3321 17.0916 61.3321H29.4315C33.333 61.3321 36.4958 58.1693 36.4958 54.2678V52.6418C36.4958 48.7403 33.333 45.5775 29.4315 45.5775Z",
    fill: "white",
    stroke: "#03324C",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3969 17.2783V29.6182C45.3969 33.5197 48.5596 36.6824 52.4611 36.6824H54.0872C57.9887 36.6824 61.1515 33.5197 61.1515 29.6182V17.2783C61.1515 13.3768 57.9887 10.214 54.0872 10.214H52.4611C48.5596 10.214 45.3969 13.3768 45.3969 17.2783Z",
    fill: "white",
    stroke: "#03324C",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3969 77.2975V89.6374C45.3969 93.5389 48.5596 96.7017 52.4611 96.7017H54.0872C57.9887 96.7017 61.1515 93.5389 61.1515 89.6374V77.2975C61.1515 73.396 57.9887 70.2332 54.0872 70.2332H52.4611C48.5596 70.2332 45.3969 73.396 45.3969 77.2975Z",
    fill: "white",
    stroke: "#03324C",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifePreserver);
export default __webpack_public_path__ + "static/media/life-preserver.ea6780dfcde2ef229605111651d615c3.svg";
export { ForwardRef as ReactComponent };